import { render, staticRenderFns } from "./DetailOffer.vue?vue&type=template&id=8d54e2e8&"
import script from "./DetailOffer.vue?vue&type=script&lang=js&"
export * from "./DetailOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports